import LoginSaml from "./LoginSaml";

export default LoginSaml;
